module.exports = __webpack_public_path__ + "img/upload.a7e6a0b0.png";